import React from "react";
import * as Mui from "@mui/material";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { getPayload, RootState } from "redux/store";
import { Agent } from "model/agent";
import { RichTextEditor } from "component/shared/rich-text-editor";
import { updateAgent } from "redux/slice/agents";
import { SaveButton } from "component/shared/save-button";

interface Props extends OwnProps,
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>
	{}

interface OwnProps {
	agent: Agent;
}

interface State {
	header: string;
}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
	return {
		loading: state.agents.loading,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators(
		{
			updateAgent,
		},
		dispatch
	);
};

class Component extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			header: this.props.agent.emailHeader || "",
		};
	}

	private async save() {
		const { agent } = this.props;
		const { header } = this.state;
		getPayload(await this.props.updateAgent( 
			{ agent: 
				{
					...agent,
					emailHeader: header,
				}
			})
		);
	}

	render() {
		const { loading } = this.props;
		const { header } = this.state;
		return (
			<Mui.Grid container spacing={1}>
				<Mui.Grid container	alignItems="center"	justifyContent="center"	spacing={2}>
					<Mui.Grid item xs={12}>
						<Mui.Typography>
							Agent-Specific Email Update Header
						</Mui.Typography>
					</Mui.Grid>
					<Mui.Grid item xs={12}>
						<Mui.Typography>
							Enter text or HTML that appears at the top of the email updates sent to this agent's leads. If left blank, a simple contact message will appear.
						</Mui.Typography>
					</Mui.Grid>
					<Mui.Grid item xs={12}>
						<RichTextEditor
							onChange={(text) =>
								this.setState({ header: text })
							}
							toolbarId="emailHeader"
							value={header}
						/>
					</Mui.Grid>
					<Mui.Grid item xs={12}>
						<SaveButton 
							loading={loading || false}
							snackBar
							label={{
								primary: "Save",
								inProgress: "Saving...",
								completed: "Saved"
							}}
							onClick={() => this.save()}					
						/>
					</Mui.Grid>
				</Mui.Grid>
			</Mui.Grid>
		);
	}
}

export const LeadCaptureTab = connect(mapStateToProps, mapDispatchToProps)(Component);